/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Media_Communication_Marketing27Inputs */

const en_job_form_enum_media_communication_marketing27 = /** @type {(inputs: Job_Form_Enum_Media_Communication_Marketing27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media, Communication and Marketing`)
};

const de_job_form_enum_media_communication_marketing27 = /** @type {(inputs: Job_Form_Enum_Media_Communication_Marketing27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien, Kommunikation und Marketing`)
};

/**
* | output |
* | --- |
* | "Media, Communication and Marketing" |
*
* @param {Job_Form_Enum_Media_Communication_Marketing27Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_media_communication_marketing27 = /** @type {((inputs?: Job_Form_Enum_Media_Communication_Marketing27Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Media_Communication_Marketing27Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_media_communication_marketing27(inputs)
	return en_job_form_enum_media_communication_marketing27(inputs)
});
export { job_form_enum_media_communication_marketing27 as "job_form_enum_MEDIA_COMMUNICATION_MARKETING" }